// eslint-disable-next-line no-shadow
export enum FeedViews {
	LIST = 'list',
	GRID = 'grid',
	SMALL = 'small',
	MEDIUM = 'medium',
	LARGE = 'large',
}
